import { makeCell, makeRowSet } from './gridUtill';

let fields = [];
let columns = [];

// 사내통용 원료명칭 컬럼
makeCell(
  1,
  [
    {
      field: 'internalMaterialName',
      alias: '사내통용 원료명칭',
      indexExclusive: true,
    },
  ],
  fields,
  columns,
  300, // 컬럼 너비 설정
);

const rowSet = makeRowSet(fields);
const errorMessage = '검색된 사내통용 원료명칭이 없습니다';
const hideCheckBar = false; // 체크박스 활성화 (선택용)

export { fields, columns, rowSet, errorMessage, hideCheckBar }; 